<script>
import { sendToMixPanel } from '@/_utilities/seerMixPanel';
import { MIXPANEL_EVENTS } from '../_utilities/Enums';

/** Handles Chrome extension Dropzone */
export default {
  data() {
    return {
      canReceiveDrop: false,
      canReceiveDropCounter: 0, // https://stackoverflow.com/questions/7110353/html5-dragleave-fired-when-hovering-a-child-element
    };
  },
  computed: {
    dropClasses() {
      return { 'drop-active': this.canReceiveDrop };
    },
  },
  methods: {
    onDragOver(evt) {},
    onDragEnter(evt) {
      if (evt.dataTransfer.types.includes('product')) {
        this.canReceiveDrop = true;
        this.canReceiveDropCounter += 1;
      }
    },
    onDragLeave(evt) {
      this.canReceiveDropCounter -= 1;

      if (this.canReceiveDropCounter <= 0) {
        this.canReceiveDrop = false;
        this.canReceiveDropCounter = 0;
      }
    },
    onDrop(evt) {
      const productMetadataString = evt.dataTransfer.getData('product');

      if (productMetadataString) {
        const productMetadata = JSON.parse(productMetadataString);
        const NO_EXTRA_FABRICJS_ARGS = {};

        sendToMixPanel(MIXPANEL_EVENTS.addImage, {
          source: 'browser',
          location: 'collage',
          image_url: productMetadata?.image_url,
        });

        if (typeof this.addBase64Image === 'function') {
          this.addBase64Image(productMetadata.image_url, NO_EXTRA_FABRICJS_ARGS, productMetadata);
        } else {
          console.log('No uploader function was found');
        }

        // Resets the content
        this.canReceiveDrop = false;
        this.canReceiveDropCounter = 0;
      }
    },
  },
};
</script>
